import { sorterDispatcher } from '@app/utils/table'

import type { Column } from '@app/components/base/Table/types'
import type { TemplatesListDataSource } from '../types'

export const getColumns = (): Array<Column<TemplatesListDataSource>> => {
  return [
    {
      key: 'message',
      dataIndex: 'message',
      title: 'Шаблон',
      sorter: (a, b) => sorterDispatcher(a.message, b.message)
    }
  ]
}
